export default __webpack_public_path__ + "static/brandlogo-51c1c25131ac514c00145cb2475c998a.svg";